import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

const ArchiveCard = styled(Card)(({ archived, theme }) => ({
  border: archived ? `2px solid ${(theme.vars || theme).palette.archived}` : '',
}));

export default ArchiveCard;
